const PERMISSIONS: any = {
  CAN_VIEW_ABOUT: "view_about",
  CAN_VIEW_EXTRA: "view_extra",
  CAN_VIEW_ALL: "view_all",
};

export default PERMISSIONS;
